import React, { useCallback, useEffect, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import "../usuarios/usuarios_style.css";
import "./style.css";
import ScrollToTop from "../../../../components/scrollToTop/scrollToTop";
import { Modal, Button, Table } from "react-bootstrap";
import { FaArrowAltCircleDown } from "react-icons/fa";
import DOMPurify from "dompurify";

const CELL_TRUNCATE_LIMIT = 50;

const TABLE_COLUMNS = [
  { key: "id", label: "ID" },
  { key: "vuelo", label: "Vuelo" },
  { key: "fecha_hora_salida", label: "Fecha Hora Salida" },
  { key: "origen_ciudad", label: "Origen Ciudad" },
  { key: "origen_pais", label: "Origen País" },
  { key: "fecha_hora_llegada", label: "Fecha Hora Llegada" },
  { key: "destino_1", label: "Destino 1" },
  { key: "destino_2", label: "Destino 2" },
  { key: "awb", label: "AWB" },
  { key: "awb_origen", label: "AWB Origen" },
  { key: "awb_destino", label: "AWB Destino" },
  { key: "piezas", label: "Piezas" },
  { key: "slac", label: "SLAC" },
  { key: "t_count", label: "T Count" },
  { key: "peso_kg", label: "Peso Kg" },
  { key: "volumen_m3", label: "Volumen m3" },
  { key: "descripcion", label: "Descripción" },
  { key: "codigo_especial_1", label: "Código Especial 1" },
  { key: "codigo_especial_2", label: "Código Especial 2" },
  { key: "codigo_especial_3", label: "Código Especial 3" },
  { key: "dimensiones", label: "Dimensiones" },
  { key: "uld_id", label: "ULD ID" },
  { key: "uld_prioridad", label: "ULD Prioridad" },
  { key: "uld_descripcion", label: "ULD Descripción" },
  { key: "comentarios_oci", label: "Comentarios OCI" },
  { key: "uld_notas", label: "ULD Notas" },
  { key: "created_at", label: "Fecha Registro" },
];

function ReporteFFM() {
  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [dataPerPage, setDataPerPage] = useState(10);
  const [totalRows, setTotalRows] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [appliedStartDate, setAppliedStartDate] = useState("");
  const [appliedEndDate, setAppliedEndDate] = useState("");

  const [showHistoryModal, setShowHistoryModal] = useState(false);
  const [historyData, setHistoryData] = useState([]);
  const [historyPage, setHistoryPage] = useState(1);
  const [historyPerPage] = useState(5);
  const [isLoadingHistory, setIsLoadingHistory] = useState(false);

  const [showCellModal, setShowCellModal] = useState(false);
  const [cellModalContent, setCellModalContent] = useState("");
  const [cellModalTitle, setCellModalTitle] = useState("");

  const pageNumbers = [];
  const maxPageNumbersToShow = 20;

  let startPage = 1;
  let endPage = totalPages;

  if (totalPages > maxPageNumbersToShow) {
    startPage = Math.max(1, currentPage - Math.floor(maxPageNumbersToShow / 2));
    endPage = Math.min(totalPages, startPage + maxPageNumbersToShow - 1);

    if (endPage - startPage < maxPageNumbersToShow) {
      startPage = endPage - maxPageNumbersToShow + 1;
    }
  }

  for (let i = startPage; i <= endPage; i += 1) {
    pageNumbers.push(i);
  }

  const indexOfLastHistory = historyPage * historyPerPage;
  const indexOfFirstHistory = indexOfLastHistory - historyPerPage;
  const currentHistoryData = historyData.slice(
    indexOfFirstHistory,
    indexOfLastHistory,
  );
  const totalHistoryPages = Math.ceil(historyData.length / historyPerPage);

  const formatDateForAPI = (dateString, isStart = true) => {
    const [year, month, day] = dateString.split("-").map(Number);
    const date = new Date(Date.UTC(year, month - 1, day));

    if (isStart) {
      return `${date.toISOString().split("T")[0]} 00:00:00`;
    }

    return `${date.toISOString().split("T")[0]} 23:59:59`;
  };

  const validateDateRange = (start, end) => {
    const parsedStartDate = new Date(start);
    const parsedEndDate = new Date(end);
    const diffTime = Math.abs(parsedEndDate - parsedStartDate);
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return diffDays <= 30;
  };

  const fetchFfmReports = useCallback(
    async ({
      page = 1,
      limit = 10,
      startDate: nextStartDate = "",
      endDate: nextEndDate = "",
    } = {}) => {
      setIsLoading(true);

      try {
        const params = new URLSearchParams();
        params.append("page", String(page));
        params.append("limit", String(limit));

        if (nextStartDate && nextEndDate) {
          params.append("date_init", formatDateForAPI(nextStartDate, true));
          params.append("date_finish", formatDateForAPI(nextEndDate, false));
        }

        const res = await axios.get(
          `${process.env.REACT_APP_URL_BACKEND}/api/v1/reports/ffm?${params.toString()}`,
          {
            headers: {
              Authorization: `Bearer ${sessionStorage.getItem("token")}`,
            },
          },
        );

        if (res.data.code === 1) {
          const rows = Array.isArray(res.data.data) ? [...res.data.data] : [];

          rows.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));

          const pagination = res.data.pagination || {};
          const backendPage = Number(pagination.page) || page;
          const backendLimit = Number(pagination.limit) || limit;
          const backendTotalPages = Number(pagination.totalPages) || 0;
          const backendTotalRows = Number(pagination.total) || 0;

          setData(rows);
          setCurrentPage(backendPage);
          setDataPerPage(backendLimit);
          setTotalPages(backendTotalPages);
          setTotalRows(backendTotalRows);
          return;
        }

        setData([]);
        setTotalPages(0);
        setTotalRows(0);
      } catch (error) {
        Swal.fire("Error", "Hubo un error", "error");
      } finally {
        setIsLoading(false);
      }
    },
    [],
  );

  useEffect(() => {
    fetchFfmReports({
      page: 1,
      limit: 10,
      startDate: "",
      endDate: "",
    });
  }, [fetchFfmReports]);

  const paginate = async (pageNumber) => {
    if (
      pageNumber < 1 ||
      pageNumber > totalPages ||
      pageNumber === currentPage
    ) {
      return;
    }

    setCurrentPage(pageNumber);

    await fetchFfmReports({
      page: pageNumber,
      limit: dataPerPage,
      startDate: appliedStartDate,
      endDate: appliedEndDate,
    });
  };

  const showEntries = async (e) => {
    const newLimit = Number(e.target.value);

    setDataPerPage(newLimit);
    setCurrentPage(1);

    await fetchFfmReports({
      page: 1,
      limit: newLimit,
      startDate: appliedStartDate,
      endDate: appliedEndDate,
    });
  };

  const handleSearch = async () => {
    const hasStart = !!startDate;
    const hasEnd = !!endDate;

    if (hasStart && !hasEnd) {
      Swal.fire("Error", "Debes seleccionar la fecha de fin", "error");
      return;
    }

    if (!hasStart && hasEnd) {
      Swal.fire("Error", "Debes seleccionar la fecha de inicio", "error");
      return;
    }

    if (hasStart && hasEnd) {
      if (new Date(startDate) > new Date(endDate)) {
        Swal.fire(
          "Error",
          "La fecha de inicio no puede ser mayor que la de fin",
          "error",
        );
        return;
      }

      if (!validateDateRange(startDate, endDate)) {
        Swal.fire(
          "Error",
          "El rango de fechas no puede ser mayor a 31 días",
          "error",
        );
        return;
      }

      setAppliedStartDate(startDate);
      setAppliedEndDate(endDate);
      setCurrentPage(1);

      await fetchFfmReports({
        page: 1,
        limit: dataPerPage,
        startDate,
        endDate,
      });
      return;
    }

    Swal.fire("Error", "Selecciona un rango de fechas", "error");
  };

  const clearDateFilter = async () => {
    setStartDate("");
    setEndDate("");
    setAppliedStartDate("");
    setAppliedEndDate("");
    setCurrentPage(1);

    await fetchFfmReports({
      page: 1,
      limit: dataPerPage,
      startDate: "",
      endDate: "",
    });
  };


  const openCellModal = (title, content) => {
    setCellModalTitle(title);
    setCellModalContent(content);
    setShowCellModal(true);
  };

  const formatDateHuman = (dateString) => {
    if (!dateString) {
      return "-";
    }

    const date = new Date(dateString);

    return new Intl.DateTimeFormat("es-CO", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
      timeZone: "UTC",
    }).format(date);
  };

  const formatCellValue = (key, value) => {
    if (value === null || value === undefined || value === "") {
      return "-";
    }

    if (key === "created_at") {
      return formatDateHuman(value);
    }

    return value;
  };

  const dowloadExcel = async () => {
    const hasStart = !!startDate;
    const hasEnd = !!endDate;

    try {
      if (!hasStart && !hasEnd) {
        Swal.fire(
          "Error",
          "Debes seleccionar las fechas de inicio y fin",
          "error",
        );
        return;
      }

      if (hasStart && !hasEnd) {
        Swal.fire("Error", "Debes seleccionar la fecha de fin", "error");
        return;
      }

      if (!hasStart && hasEnd) {
        Swal.fire("Error", "Debes seleccionar la fecha de inicio", "error");
        return;
      }

      if (new Date(startDate) > new Date(endDate)) {
        Swal.fire(
          "Error",
          "La fecha de inicio no puede ser mayor que la de fin",
          "error",
        );
        return;
      }

      if (!validateDateRange(startDate, endDate)) {
        Swal.fire(
          "Error",
          "El rango de fechas para exportar no puede ser mayor a 30 días",
          "error",
        );
        return;
      }

      const body = {
        taskType: "generateFfmReportExcel",
        payload: {
          start_date: formatDateForAPI(startDate, true),
          end_date: formatDateForAPI(endDate, false),
        },
      };

      await axios.post(
        `${process.env.REACT_APP_URL_BACKEND}/api/v1/cronjob/testSqs`,
        body,
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
        },
      );
      Swal.fire("Creado!", "El reporte se está generando.", "success");
    } catch (error) {
      console.error(error);
      Swal.fire("Error", "No se pudo generar el reporte", "error");
    }
  };

  const openHistoryModal = () => {
    setShowHistoryModal(true);
    fetchHistoryData();
  };

  const fetchHistoryData = async () => {
    setIsLoadingHistory(true);
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_URL_BACKEND}/api/v1/reports/ffm/files`,
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
        },
      );

      if (res.data.code === 1) {
        setHistoryData(res.data.data);
      }
    } catch (error) {
      Swal.fire("Error", "No se pudo cargar el historial", "error");
    } finally {
      setIsLoadingHistory(false);
    }
  };

  function getFileNameFromPath(path) {
    return path.replace("gcp/ffm/", "");
  }

  const safeURL = (url) => {
    if (typeof url !== "string" || url.trim() === "") {
      return "#";
    }
    try {
      const parsed = new URL(url);

      if (parsed.protocol !== "http:" && parsed.protocol !== "https:") {
        return "#";
      }

      return DOMPurify.sanitize(parsed.href);
    } catch (error) {
      return "#";
    }
  };

  return (
    <>
      <ScrollToTop />
      <div>
        <div
          className="dataTables_wrapper dt-bootstrap4 no-footer m-1"
          id="datatables_wrapper"
        >
          <div className="row justify-content-between mb-2">
            <div className="col-sm-12 col-md-3">
              <div className="dataTables_length" id="dataTables_length">
                <label className="d-flex justify-content-end">
                  <span className="mr-2 p-2">Mostrar</span>
                  <select
                    name="datatables_length"
                    aria-controls="datatables_length"
                    className="custom-select custom-select-sm form-control-sm narrow-select p-2"
                    value={dataPerPage}
                    onChange={showEntries}
                  >
                    <option value="10">10</option>
                    <option value="25">25</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                  </select>
                  <span className="ml-2 p-2">Registros</span>
                </label>
              </div>
            </div>
            <div className="col-sm-12 col-md-9">
              <div className="datatables_filter" id="datatables_filter">
                <label className="d-flex justify-content-end">
                  <input
                    type="date"
                    id="start_date"
                    name="start_date"
                    value={startDate}
                    onChange={(e) => setStartDate(e.target.value)}
                    className="form-control form-control-sm"
                    aria-controls="datatables"
                  />

                  <span className="mr-2 mt1 p-2"></span>

                  <input
                    type="date"
                    id="end_date"
                    name="end_date"
                    value={endDate}
                    onChange={(e) => setEndDate(e.target.value)}
                    className="form-control form-control-sm"
                    aria-controls="datatables"
                  />

                  <button className="btn-amc-blue ml-2" onClick={handleSearch}>
                    Buscar
                  </button>

                  <button
                    className="btn-amc-pink ml-2"
                    onClick={clearDateFilter}
                  >
                    Limpiar
                  </button>

                  <button className="btn-amc-pink ml-2" onClick={dowloadExcel}>
                    Exportar
                  </button>

                  <button
                    className="btn-amc-turq ml-2"
                    onClick={openHistoryModal}
                  >
                    Historial
                  </button>
                </label>
              </div>
            </div>
          </div>

          <div className="table-responsive">
            <table
              className="table table-inverse table-hover table-striped table-bordered dataTable no-footer"
              role="grid"
              aria-describedby="datatables_info"
              style={{ whiteSpace: "nowrap" }}
            >
              <thead>
                <tr role="row">
                  {TABLE_COLUMNS.map((column) => (
                    <th
                      key={column.key}
                      className="sorting"
                      tabIndex={0}
                      aria-controls="datatables"
                      rowSpan={1}
                      colSpan={1}
                      style={{ width: "auto", minWidth: "130px" }}
                    >
                      {column.label}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {isLoading ? (
                  <tr>
                    <td colSpan={TABLE_COLUMNS.length} className="text-center">
                      <div className="d-flex justify-content-center align-items-center">
                        <div
                          className="spinner-border text-primary"
                          role="status"
                        >
                          <span className="sr-only"></span>
                        </div>
                        <span className="ml-2">Cargando...</span>
                      </div>
                    </td>
                  </tr>
                ) : data.length > 0 ? (
                  data.map((row) => (
                    <tr key={row.id}>
                      {TABLE_COLUMNS.map((column) => {
                        const value = formatCellValue(
                          column.key,
                          row[column.key],
                        );
                        const isLong =
                          typeof value === "string" &&
                          value.length > CELL_TRUNCATE_LIMIT;
                        return (
                          <td key={`${row.id}-${column.key}`}>
                            {isLong ? (
                              <>
                                {value.substring(0, CELL_TRUNCATE_LIMIT)}...{" "}
                                <button
                                  style={{
                                    border: "none",
                                    background: "transparent",
                                    textDecorationLine: "underline",
                                    color: "#375b8b",
                                    cursor: "pointer",
                                    padding: 0,
                                  }}
                                  onClick={() =>
                                    openCellModal(column.label, value)
                                  }
                                >
                                  Ver más
                                </button>
                              </>
                            ) : (
                              value
                            )}
                          </td>
                        );
                      })}
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={TABLE_COLUMNS.length} className="text-center">
                      No hay datos
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          <div className="row">
            <nav aria-label="Page navigation example">
              <ul className="pagination">
                <li className="page-item">
                  <button
                    className="page-link"
                    onClick={() => paginate(currentPage - 1)}
                    disabled={currentPage === 1 || totalRows === 0 || isLoading}
                  >
                    Anterior
                  </button>
                </li>
                {pageNumbers.map((pageNumber) => (
                  <li className="page-item" key={pageNumber}>
                    <button
                      className="page-link"
                      onClick={() => paginate(pageNumber)}
                    >
                      {pageNumber}
                    </button>
                  </li>
                ))}
                <li className="page-item">
                  <button
                    className="page-link"
                    onClick={() => paginate(currentPage + 1)}
                    disabled={
                      currentPage >= totalPages || totalRows === 0 || isLoading
                    }
                  >
                    Siguiente
                  </button>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </div>

      <Modal
        show={showCellModal}
        onHide={() => setShowCellModal(false)}
        size="lg"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>{cellModalTitle}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <pre style={{ whiteSpace: "pre-wrap", wordWrap: "break-word" }}>
            {cellModalContent}
          </pre>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowCellModal(false)}>
            Cerrar
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showHistoryModal}
        onHide={() => setShowHistoryModal(false)}
        size="lg"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Historial de Registros</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {isLoadingHistory ? (
            <div className="text-center">
              <div className="spinner-border text-primary" role="status">
                <span className="sr-only"></span>
              </div>
              <p>Cargando historial...</p>
            </div>
          ) : historyData.length === 0 ? (
            <p className="text-center">No hay registros en el historial</p>
          ) : (
            <>
              <Table striped bordered hover responsive>
                <thead>
                  <tr>
                    <th>Nombre</th>
                    <th>Creado</th>
                    <th>Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  {currentHistoryData.map((item, index) => (
                    <tr key={`${item.key}-${index}`}>
                      <td>{getFileNameFromPath(item.key)}</td>
                      <td>{formatDateHuman(item.lastModified)}</td>
                      <td>
                        <a
                          href={safeURL(item.url)}
                          download
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <Button variant="primary" size="sm">
                            <FaArrowAltCircleDown />
                          </Button>
                        </a>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
              <nav className="d-flex justify-content-center mt-3">
                <ul className="pagination">
                  <li
                    className={`page-item ${
                      historyPage === 1 ? "disabled" : ""
                    }`}
                  >
                    <button
                      className="page-link"
                      onClick={() => setHistoryPage(historyPage - 1)}
                      disabled={historyPage === 1}
                    >
                      Anterior
                    </button>
                  </li>
                  {Array.from(
                    { length: totalHistoryPages },
                    (_, i) => i + 1,
                  ).map((pageNum) => (
                    <li
                      key={pageNum}
                      className={`page-item ${
                        historyPage === pageNum ? "active" : ""
                      }`}
                    >
                      <button
                        className="page-link"
                        onClick={() => setHistoryPage(pageNum)}
                      >
                        {pageNum}
                      </button>
                    </li>
                  ))}
                  <li
                    className={`page-item ${
                      historyPage === totalHistoryPages ? "disabled" : ""
                    }`}
                  >
                    <button
                      className="page-link"
                      onClick={() => setHistoryPage(historyPage + 1)}
                      disabled={historyPage === totalHistoryPages}
                    >
                      Siguiente
                    </button>
                  </li>
                </ul>
              </nav>
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setShowHistoryModal(false)}
          >
            Cerrar
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default ReporteFFM;
